import React from 'react'
import { observer } from 'mobx-react'
import { ICollectionLink } from '../collections.interfaces'
import './collection-top-nav.scss'
import { collectionListStore as listStore } from '../collection-list/collection-list.store'
import { collectionsStore as store } from '../collections.store'
import { scrollTo } from '../../../utils'
import { runInAction } from 'mobx'
import CollectionTopNavLink from '../collection-top-nav-link/collection-top-nav-link.component'

/**
 * Displays a horizontal navigation for the collections on desktop.
 * When clicked will scroll to the corresponding collection heading.
 */
const HEIGHT = 104
const OFFSET_FIX_NAVS = 104
const OFFSET_PADDING = 18
const OFFSET_FIX_NAVS_MOBILE = 145
const SCROLL_OFFSET = HEIGHT + 30

@observer
export class CollectionTopNav extends React.Component {
  baseClass: string = 'side-menu'

  componentDidMount(): void {
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll)
    this.handleClick = this.handleClick.bind(this)
  }

  componentWillUnmount(): void {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = (): void => {
    const sectionVisibility: boolean[] = []
    const offsetFixNavs = window.innerWidth <= 768 ? OFFSET_FIX_NAVS_MOBILE : OFFSET_FIX_NAVS

    listStore.collectionRefs.forEach((ref) => {
      const { current } = ref
      if (current) sectionVisibility.push(current.offsetTop < window.pageYOffset + SCROLL_OFFSET + offsetFixNavs + window.innerHeight / 2)
    })

    runInAction(() => {
      const activeIndex: number = sectionVisibility.lastIndexOf(true)
      store.activeLink = store.links[activeIndex > -1 ? activeIndex : 0]
    })
  }

  handleClick = (event: React.MouseEvent<HTMLDivElement>, link: ICollectionLink): void => {
    event.preventDefault()
    const offsetFixNavs = window.innerWidth <= 768 ? OFFSET_FIX_NAVS_MOBILE : OFFSET_FIX_NAVS
    const { current } = listStore.collectionRefs.get(link.handle)
    if (current) scrollTo(0, current.offsetTop - SCROLL_OFFSET - offsetFixNavs - OFFSET_PADDING, 'smooth')
  }

  render(): React.ReactNode {
    return (
      <div className='container'>
        <div className='collection-top-nav'>
          {store.links
            .filter((link) => link.level === 1)
            .map((link, i) => (
              <CollectionTopNavLink
                key={link.handle}
                link={link}
                isActive={link.handle === (store.activeLink && store.activeLink.handle)}
                onClick={this.handleClick}
              />
            ))}
        </div>
      </div>
    )
  }
}
